// imports
import * as THREE from "three"

// classes
import Experience from "../Experience"

export default class AnimationController
{
    constructor()
    {
        
        // setup
        this.experience = new Experience()
        this.time = this.experience.time

        // options
        this.updateAnimation = false
        this.previousInstance = undefined
        this.previousState = undefined
    }

    animateState( _instance, _resource, _animationState )
    {
        if ( this.previousState === _animationState )
            return
        
        this.animation = {}
        this.animation.mixer = new THREE.AnimationMixer( _instance )
        this.animation.actions = {}
        _resource.animations.forEach( _animation =>
        {
            this.animation.actions[ _animation.name.toLowerCase() ] = this.animation.mixer.clipAction( _animation )
        } )
        if ( _animationState === "idle" )
        {
            Object.keys( this.animation.actions ).forEach( ( _action ) =>    
            {
                this.animation.actions[ _action ].stop()
            } )
            this.previousInstance = _instance
            this.previousState = _animationState
            return
        }
        this.animation.actions[ _animationState ].play()
        if ( this.previousState !== "idle" && this.previousState !== undefined )
        {
            this.animation.actions[ _animationState ].reset()
            this.animation.actions[ _animationState ].play()
            this.animation.actions[ _animationState ].crossFadeFrom( this.animation.actions[ this.previousState ], 1 )
        }


        this.animationSpeed = _animationState === "survey" ? 0.001 : this.animationSpeed
        this.animationSpeed = _animationState === "walk" ? 0.001 : 0.0015
        this.previousState = _animationState
        this.previousInstance = _instance
        this.updateAnimation = true
        
    }

    update()
    {
        this.animation.mixer.update( this.time.deltaTime * this.animationSpeed )
    }
}